<template>
	<div class="insideBody">
		<div class="pointsmall">
			<div class="top clr">
				<div class="people clr fl">
					<img class="fl img" :src="$url+avatar">
					<span class="fl name">{{utils.storageGet("userinfo").username}}</span>
				</div>
				<div class="fl tits">可用积分：{{leijijf}}</div>
        <div class="fl tits">累计积分：{{dataObj.jifen}}</div>
				<div class="fr btn" @click="getshophistorylist">兑换记录</div>
			</div>
			<div class="con" :style="{height: height+'px'}">
				<template v-if="countpage > 0">
					<ul class="clr" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
						<li v-for="(item,index) in tableData" :key="index">
							<img :src="$url+item.itemimg">
							<div class="tits">{{item.itemname}}</div>
							<div class="num clr">
								<div class="num_l fl">{{item.consume}}</div>
								<div class="num_r fr">库存：{{item.total}}个</div>
							</div>
							<div class="btncon">
								<div class="btn" @click="dhexchangeBlonFun(item)">立即兑换</div>
							</div>
						</li>
					</ul>
				</template>
				<template v-else>
					<div class="noneImg">
						<img src="../../assets/images/none.png">
					</div>
				</template>
				<!-- <p class="noneImg" v-if="disabled && tableData.length > 0">没有更多了</p> -->
			</div>
		</div>
		
		<div class="exchange_list" :class="exchangeBlon ? 'on':''"> <!-- 兑换记录弹窗 -->
			<div class="exchangeTc">
				<div class="tits">
					兑换记录
					<div class="zst"></div>
					<div class="btn" @click="exchangeBlon = false"></div>
				</div>
				<div class="table">
					<el-table
						:height="tabheight"
						:data="tableDatatab"
						style="width: 100%">
						<el-table-column
							align="center"
							min-width="200"
							label="礼品名称">
							<template slot-scope="scope">
								<div class="clr">
									<img class="fl img" :src="$url+scope.row.itemimg">
									<div class="name">{{scope.row.itemname}}</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column
							align="center"
							min-width="60"
							label="消耗积分">
							<template slot-scope="scope">
								<span class="red">{{'-'+scope.row.consume}}</span>
							</template>
						</el-table-column>
						<el-table-column
							align="center"
							min-width="150"
							label="日期">
							<template slot-scope="scope">
								<span class="c9">{{scope.row.time}}</span>
							</template>
						</el-table-column>
						<el-table-column
							align="center"
							min-width="60"
							label="状态">
							<template slot-scope="scope">
								<span class="c6">{{scope.row.state | state}}</span>
							</template>
						</el-table-column>
					</el-table>
					<div class="btncon">
						<div class="btn" @click="exchangeBlon = false">关 闭</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="exchange_list dhexchange_list" :class="dhexchangeBlon ? 'on':''"> <!-- 兑换提示窗 -->
			<div class="exchangeTc">
				<div class="tits">
					兑换提示
					<div class="btn" @click="dhexchangeBlon = false"></div>
				</div>
				<div class="content">
					<div class="titcon">
						<template v-if="dataObj.leijijf >= dhexchangeObj.consume">
							你将花费<span>{{dhexchangeObj.consume}}</span>积分兑换以下商品
						</template>
						<template v-else>
							抱歉，你的积分不足，无法兑换
						</template>
					</div>
					<div class="cont clr">
						<img class="img fl" :src="$url+dhexchangeObj.itemimg">
						<div class="name">{{dhexchangeObj.itemname}}</div>
					</div>
					<div class="btncon">
						<div class="btn" v-if="dataObj.leijijf >= dhexchangeObj.consume" @click="doshop">确 认</div>
						<div class="btn" @click="dhexchangeBlon = false">{{dataObj.leijijf >= dhexchangeObj.consume?'取 消':'关 闭'}}</div>
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>
<script>
import {getshoplist,getshophistorylist,doshop} from '@/api/control4'
export default {
  data(){
    return {
			height: null,
			limit: 10,
			page: 0,
			countpage: 1,
			disabled: false,
			tableData: [],
			dataObj: {},
			avatar: this.utils.storageGet("userinfo").avatar,
			tabheight: null,
			exchangeBlon: false,
			dhexchangeBlon: false,
			dhexchangeObj:{},
			tableDatatab:[],
      leijijf: ' - ',
		};
	},
	created(){
		this.datalist();
	},
	filters: {
	  state(value){
			var name = '';
			if(value == 1){
				name = '准备中';
			}else if(value == 2){
				name = '兑换成功';
			}else if(value == 3){
				name = '兑换失败';
			};
	    return name;
	  }
	},
	methods:{
		dhexchangeBlonFun(item){
			var that = this;
			that.dhexchangeObj = item;
			that.dhexchangeBlon = true
		},
		doshop(){
			var that = this;
			doshop({
				userid: that.utils.storageGet("userinfo").userid,
				itemid: that.dhexchangeObj.itemid,
			}).then(res => {
        that.leijijf = res;
				that.$message.success('兑换成功');
				that.dhexchangeBlon = false;
        that.datalist();
			});
		},
		getshophistorylist(){
			var that = this;
			getshophistorylist({
				userid: that.utils.storageGet("userinfo").userid,
			}).then(res => {
				that.tableDatatab = res.list;
				that.exchangeBlon = true
			});
		},
		datalist(){
			var that = this;
			getshoplist({
				userid: that.utils.storageGet("userinfo").userid,
				limit: 62355,
				page: 1
			}).then(res => {
				that.dataObj = res;
        that.leijijf = res.leijijf;
				that.countpage = Math.ceil(res.count / that.limit);
				that.tableData = res.list;
				if(that.page >= that.countpage){
					that.disabled = true;
				};
			});
		},
		load(){
			// var that = this;
			// this.page += 1;
			// that.datalist();
		},
	},
	mounted(){
		var that = this;
		that.height = window.innerHeight - (340*that.utils.per());
		that.tabheight = window.innerHeight - (600*that.utils.per());
	},
	components: {
		
	},
}
</script>
<style scoped>
	
</style>